import { render, staticRenderFns } from "./Updates.vue?vue&type=template&id=6b962726&scoped=true"
import script from "./Updates.vue?vue&type=script&lang=ts"
export * from "./Updates.vue?vue&type=script&lang=ts"
import style0 from "./Updates.vue?vue&type=style&index=0&id=6b962726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b962726",
  null
  
)

export default component.exports